/**
 * @generated SignedSource<<4cca98e411ef070918ca6968fdc69416>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingCopilotUpdateMeetingBriefSettingsMutation$variables = {
  autoGenerationDelta?: number | null;
  autoGenerationEnabled?: boolean | null;
};
export type MeetingCopilotUpdateMeetingBriefSettingsMutation$data = {
  readonly updateUserMeetingBriefSettings: {
    readonly settings: {
      readonly autoGenerationDelta: number;
      readonly autoGenerationEnabled: boolean;
      readonly id: string;
    };
  } | null;
};
export type MeetingCopilotUpdateMeetingBriefSettingsMutation$rawResponse = {
  readonly updateUserMeetingBriefSettings: {
    readonly settings: {
      readonly autoGenerationDelta: number;
      readonly autoGenerationEnabled: boolean;
      readonly id: string;
    };
  } | null;
};
export type MeetingCopilotUpdateMeetingBriefSettingsMutation = {
  rawResponse: MeetingCopilotUpdateMeetingBriefSettingsMutation$rawResponse;
  response: MeetingCopilotUpdateMeetingBriefSettingsMutation$data;
  variables: MeetingCopilotUpdateMeetingBriefSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoGenerationDelta"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoGenerationEnabled"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "autoGenerationDelta",
        "variableName": "autoGenerationDelta"
      },
      {
        "kind": "Variable",
        "name": "autoGenerationEnabled",
        "variableName": "autoGenerationEnabled"
      }
    ],
    "concreteType": "UpdateUserMeetingBriefSettings",
    "kind": "LinkedField",
    "name": "updateUserMeetingBriefSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserMeetingBriefSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoGenerationEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoGenerationDelta",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCopilotUpdateMeetingBriefSettingsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingCopilotUpdateMeetingBriefSettingsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "268d26685893a6354010ffc53f95404f",
    "id": null,
    "metadata": {},
    "name": "MeetingCopilotUpdateMeetingBriefSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingCopilotUpdateMeetingBriefSettingsMutation(\n  $autoGenerationEnabled: Boolean\n  $autoGenerationDelta: Int\n) {\n  updateUserMeetingBriefSettings(autoGenerationEnabled: $autoGenerationEnabled, autoGenerationDelta: $autoGenerationDelta) {\n    settings {\n      id\n      autoGenerationEnabled\n      autoGenerationDelta\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1967dbbf907c71806ed8520ef9e652f";

export default node;
